import React from "react";

import {
  Divider,
  Drawer as MUIDrawer,
  Grid,
  IconButton,
  Paper,
  Typography,
  useMediaQuery,
  Theme,
} from "@mui/material";
import { HighlightOffTwoTone as CloseIcon } from "@mui/icons-material";

import PerfectScrollbar from "react-perfect-scrollbar";

import Button from "components/button";
import {
  buttonsGrid12,
  titleGrid12,
  stickyToTop,
  stickyToBottom,
  divider,
} from "./index.styles";
import { footerCancelBtnStyle } from "features/products/index.styles";

const Drawer = ({
  title,
  buttonText,
  position,
  children,
  sx,
  onClose,
  open,
  onClick,
  handleCancelClick,
  disabled,
}: {
  title: React.ReactNode | string;
  buttonText: string;
  position?: "left" | "top" | "right" | "bottom";
  children: React.ReactNode;
  sx?: Object;
  open: boolean;
  disabled?: boolean;
  onClose: (event: React.SyntheticEvent<{}>) => void;
  onClick: (event?: React.MouseEvent<HTMLButtonElement>) => void;
  handleCancelClick: (event?: React.MouseEvent<HTMLButtonElement>) => void;
}) => {
  const isScreenSmall = useMediaQuery((theme: Theme) =>
    theme.breakpoints.down("sm")
  );
  const isMediumScreen = useMediaQuery((theme: Theme) =>
    theme.breakpoints.down("md")
  );

  return (
    <MUIDrawer
      open={open}
      onClose={onClose}
      anchor={position ? position : "right"}
      disableEnforceFocus
    >
      <Paper
        sx={{
          height: "100vh",
          width: { xs: "90vw", md: "39vw" },
          scrollbarWidth: "none",
          overflowX: "hidden",
          ...sx,
        }}
      >
        <Grid container sx={{ ...stickyToTop, ...divider }}>
          <Grid item xs={12} sx={titleGrid12}>
            <Typography variant="h2" sx={{ color: "#212121" }}>
              {title}
            </Typography>

            <IconButton onClick={onClose} sx={{ p: "unset" }}>
              <CloseIcon htmlColor="#D84315" fontSize="large" />
            </IconButton>
          </Grid>
        </Grid>

        <div
          style={{
            height: "calc(100vh - 181px)",
            overflowX: "hidden",
            scrollbarWidth: "thin",
          }}
        >
          {children}
        </div>

        <Grid container sx={{ ...stickyToBottom, ...divider }}>
          <Grid item xs={12} sx={buttonsGrid12}>
            <Button
              variant={"contained"}
              sx={footerCancelBtnStyle}
              onClick={handleCancelClick}
              disabled={disabled}
            >
              Cancel
            </Button>

            <Button
              variant={"contained"}
              sx={{
                p:
                  isScreenSmall || isMediumScreen
                    ? "12px 24.5px"
                    : "12px 34.5px",
                ml: "12px",
              }}
              color={"secondary"}
              onClick={onClick}
              disabled={disabled}
            >
              {buttonText}
            </Button>
          </Grid>
        </Grid>
      </Paper>
    </MUIDrawer>
  );
};

export default Drawer;
